<template>
  <ul class="sidenav app-sidenav" :class="{open: open}">
    <router-link v-for="link in links" :key="link.url" tag="li" active-class="active" :to="link.url" :exact="link.exact">
      <a href="#" class="waves-effect waves-orange pointer">{{link.name}}</a>
    </router-link>
  </ul>
</template>

<script>
    import langFilter from "../../filters/lang.filter";
export default {
  props:['open'],
  data: () => ({
    links: [
      { name: langFilter("bill"), url: "/", exact: true},
      { name: langFilter("history"), url: "/history", },
      { name: langFilter("planing"), url: "/planning", },
      { name: langFilter("newRecord"), url: "/record", },
      { name: langFilter("categories"), url: "/categories", }
      ]
  })
};
</script>
